import React, { Component } from 'react'

interface ProgressProps {
  total: number
  completed: number
}

export default class Progress extends Component<ProgressProps> {
  get status () {
    const { total, completed } = this.props
    return `${completed} out of ${total} completed`
  }

  get barStyle () {
    const { total, completed } = this.props
    const percentage = (completed / total) * 100
    const width = `${percentage}%`
    return { width }
  }

  render () {
    return (
      <div className="mb-4">
        <div className="text-secondary mb-1">
          {this.status}
        </div>
        <div className="h-2 mb-4 flex bg-tertiary">
          <div
            className="bg-primary transition-width"
            style={this.barStyle} />
        </div>
      </div>
    )
  }
}
